/* eslint-disable no-unused-vars */
// LQC-2254 - portfolios of the user originating the trade, from GET /Portfolios.
// A scratch-built block has to name the portfolio it belongs to, and that portfolio
// must match one the back end already knows about - hence the searchable store.

// Field keys as the endpoint returns them. Use these instead of string literals in
// search field lists, colDefs and lookups so a contract change breaks the build.
export enum PortfolioField {
  customerCode = "customerCode",
  lei = "lei",
  portfolioCode = "portfolioCode",
  portfolioName = "portfolioName",
}

export interface IPortfolio {
  [PortfolioField.customerCode]: string;
  [PortfolioField.lei]: string;
  [PortfolioField.portfolioCode]: string;
  [PortfolioField.portfolioName]: string;
}

// GET /Portfolios
export interface IPortfoliosResponse {
  portfolios: IPortfolio[];
}

// What a user types to find a portfolio. Order is the ranking tiebreak: code first
// (what gets sent), then the readable name, then the customer.
export const PORTFOLIO_SEARCH_FIELDS: PortfolioField[] = [
  PortfolioField.portfolioCode,
  PortfolioField.portfolioName,
  PortfolioField.customerCode,
];

// The field that identifies a portfolio to the back end.
export const PORTFOLIO_KEY_FIELD = PortfolioField.portfolioCode;
